import { createFileRoute } from '@tanstack/react-router';

import { PatternGalleryPage } from '@/pages/pattern-gallery/pattern-gallery-page';

export const Route = createFileRoute('/pattern-editor/')({
    component: PatternGalleryRoute,
});

function PatternGalleryRoute() {
    return <PatternGalleryPage />;
}
